<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-08 15:01:38
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:49:16
 * @name: 下级部门
 * @Description: 下级部门
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\children-list.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="childrenList">
    <font class="title">下级部门</font>
    <div class="head">
      <el-button size="mini" plain @click="add">添加子部门</el-button>
    </div>
    <div class="list">
      <div
        class="item"
        v-for="item of mailList.treeNode.child"
        :key="item.id"
        @click="itemClick(item)"
      >
        <font>{{ item.department_name }}</font>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div
        class="noResult"
        v-if="!mailList.treeNode.child || mailList.treeNode.child.length === 0"
      >
        <font>暂无下级部门</font>
      </div>
    </div>
    <add-department :mailList="mailList" ref="add"></add-department>
  </div>
</template>
<script>
import addDepartment from "./dialog/add-department.vue";
import { debounceation } from "@/utils/decorator";
export default {
  name: "mailList-Content-childrenList",
  components: {
    addDepartment,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击下级部门项
     * @param {Object} item 下级部门数据
     */
    @debounceation(300)
    itemClick(item) {
      this.mailList.activeTreeNode(item);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击添加子部门
     */
    @debounceation(300)
    add() {
      this.$refs.add.open();
    },
  },
};
</script>
<style lang="scss" scoped>
$lineHeight: 40px;
$padding: 20px;
.childrenList {
  width: 100%;
  @extend .extend-flex-column-normal;
  .title {
    padding: 10px 30px;
    font-size: $Vars-font-title-size;
  }
  .head {
    width: 100%;
    height: $lineHeight;
    box-sizing: border-box;
    padding: 0 $padding;
    @extend .extend-flex-start;
    background: $Vars-background-bar-normal;
  }
  .list {
    width: 100%;
    @extend .extend-flex-column-normal;
    .item {
      width: 100%;
      height: $lineHeight;
      border-bottom: 1px solid $Vars-border-third-color;
      box-sizing: border-box;
      padding: 0 calc(2 * #{$padding});
      @extend .extend-flex-spacebetween;
      @extend .extend-clickElement;
      font {
        font-size: $Vars-font-miniContent-size;
        color: $Vars-font-secondary-color;
      }
      i {
        font-size: $Vars-font-miniContent-size;
        color: $Vars-font-normal-color;
      }
    }
    .noResult {
      width: 100%;
      height: calc(2 * #{$lineHeight});
      @extend .extend-flex-center;
      font-size: $Vars-font-miniTitle-size;
    }
  }
}
</style>